import React from 'react';

import withPensionExpertTier from '../../util/pensionExpertTier/withPensionExpertTier';

import withdrawalPlantImg from '../../assets/images/retirementIncome/withdrawal-plant.svg';
import styles from './SERPSAtRetirementCard.css';

const AtRetirementCard = ({ expertRoleTitle, isPoolExpert }) => {
  return (
    <div>
      <img src={withdrawalPlantImg} alt={'Withdrawal plant'} />
      <h4 className={styles.heading}>{'At retirement'}</h4>
      <div className={styles.text}>
        {isPoolExpert
          ? "Withdrawing from your pension is a major decision that will have an impact on your income in retirement. We're with you every step of the way. By becoming a Profile Pensions customer, you'll be able to speak to our Pension Experts team to help you plan your retirement."
          : `Withdrawing from your pension is a major decision that will have an impact on your income in retirement. We're with you every step of the way. By becoming a Profile Pensions customer, you'll be able to speak to your dedicated ${expertRoleTitle} to help you plan your retirement.`}
      </div>
    </div>
  );
};

export default withPensionExpertTier(AtRetirementCard);
